var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('Menu'),_c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"side"},[_c('tools-side-menu')],1),_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }